import React, { createContext, useState, useEffect, useContext } from "react";
import { getDecodedToken } from "../utils/token";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState(
    getDecodedToken(localStorage.getItem("token")),
  );

  // Load token from localStorage on mount
  useEffect(() => {
    const token = localStorage.getItem("token"); // Check localStorage for token
    if (token) {
      setAuthState(getDecodedToken(token)); // Set token in state if it exists
    }
  }, []);

  // Function to log in
  const login = (token) => {
    setAuthState(getDecodedToken(token)); // Update auth state
    localStorage.setItem("token", token); // Store token in localStorage
  };

  // Function to log out
  const logout = () => {
    localStorage.removeItem("token"); // Clear token from localStorage
    setAuthState(null); // Update auth state
  };

  const setUserManagedCourses = (courses) => {
    setAuthState((prev) =>
      prev ? { ...prev, coursesManaged: courses } : prev,
    );
  };

  return (
    <AuthContext.Provider
      value={{ authState, login, logout, setUserManagedCourses }}
    >
      {children}
    </AuthContext.Provider>
  );
};
const useAuthContext = () => {
  return useContext(AuthContext);
};
export { useAuthContext };
